var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{attrs:{"placeholder":_vm.datalabel,"hide-details":_vm.hideDetails,"disabled":_vm.readonly,"mask":"##:##","return-masked-value":""},on:{"blur":function($event){return _vm.validateHour()}},model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}})
}
var staticRenderFns = []

export { render, staticRenderFns }